module.exports = __webpack_public_path__ + "static/media/icon-posterga.f49ab68b.svg";